import { useEffect, useState } from "react";
import { LogOut, ChevronDown } from "lucide-react";
import { useWallet } from "@/contexts/WalletContext";

/** Header status pill — only rendered once a wallet is connected. Connecting happens
 *  contextually (mint / pool / tip panels), never from the global header. */
export default function WalletPill() {
  const { phantom, anyConnected, primaryAddress, short, disconnectPhantom } = useWallet();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const close = () => setOpen(false);
    window.addEventListener("click", close);
    return () => window.removeEventListener("click", close);
  }, [open]);

  if (!anyConnected) return null;

  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="wallet-pill-connected"
        className="inline-flex border border-[#cfff04] bg-[#121212] text-[#cfff04] font-mono uppercase tracking-widest text-[11px] px-4 py-3 items-center gap-2 hover:bg-[#1a1a1a]"
      >
        <span className="w-2 h-2 live-dot" style={{ background: "#AB9FF2" }} />
        {short(primaryAddress)}
        <ChevronDown size={12} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-64 border border-[#3a3a3a] bg-[#121212] z-50">
          <div className="px-4 py-3" data-testid="wallet-pill-row-phantom">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2" style={{ background: "#AB9FF2" }} />
                <span className="font-mono text-[11px] uppercase tracking-widest text-[#e2e2e2]">
                  Phantom
                </span>
              </div>
              <button
                onClick={disconnectPhantom}
                data-testid="wallet-pill-disconnect-phantom"
                className="text-[#d0d0d0] hover:text-[#ff3333]"
                aria-label="Disconnect Phantom"
              >
                <LogOut size={12} />
              </button>
            </div>
            <div className="font-mono text-xs text-white mt-1">{short(phantom.address)}</div>
            <div className="font-mono text-[11px] text-[#d0d0d0] mt-0.5">
              {phantom.balance === null ? "—" : `${phantom.balance.toFixed(4)} SOL`}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
